import { getGmapPlace } from "@service/google-map";
import { Input } from "./input";
import { MapPinIcon, XIcon } from "lucide-react";
import { useRef, useState } from "react";
import { GMapPlace } from "@type/google_map";
import { Button } from "./button";

interface Props {
    defaultValue?: string;
    placeholder?: string;
    onChange: (value: string, attribute?: GMapPlace | undefined) => void;
    onBlur?: (value: string) => void;
    disabled?: boolean;
}

export default function LocationGMap(props: Props) {
    const [places, setPlaces] = useState<GMapPlace[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);

    const onHandleChange = (value: string) => {
        props.onChange(value)
        getGmapPlace(value).then((res) => {
            console.log(res.data.places);
            setPlaces(res.data.places.map((place: GMapPlace) => place));
        }).catch((err) => {
            console.error(err);
        });
    }

    const clearLocation = () => {
        props.onChange("");
        setPlaces([]);
        inputRef.current?.focus();
    };

    const renderPlaceName = (place: GMapPlace) => {
        if (place.addressComponents && (place.addressComponents || []).length > 0) {
            const cityComponents: string[] = [];
            (place.addressComponents || []).forEach((component) => {
                if (component.types && ((component.types).includes("locality") ||
                    (component.types).includes("administrative_area_level_2") ||
                    (component.types).includes("country")) && component.longText !== "") {
                    cityComponents.push(component.longText);
                }
            });
            if (cityComponents.length > 0) {
                if (cityComponents.includes(place.displayName.text)) {
                    return cityComponents.join(", ");
                }
                return `${place.displayName.text}, ${cityComponents.join(", ")}`;
            }
        }

        return place.displayName.text;
    }

    const getCountryFromPlace = (place: GMapPlace): string | null => {
        if (place.addressComponents && (place.addressComponents || []).length > 0) {
            for (const component of place.addressComponents) {
                if (component.types && (component.types).includes("country")) {
                    return component.longText;
                }
            }
        }
        return null;
    }

    return (
        <div className="relative">
            <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
                ref={inputRef}
                placeholder={props.placeholder || "Start typing a city or location..."}
                value={props.defaultValue}
                onChange={(e) => onHandleChange(e.target.value)}
                onBlur={(props.onBlur) ? (e) => props.onBlur && props.onBlur(e.target.value) : undefined}
                disabled={props.disabled}
                className="pl-9 pr-10"
            />

            {props.defaultValue && (
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 p-0 hover:bg-gray-100"
                    onClick={clearLocation}
                >
                    <XIcon className="h-4 w-4 text-gray-400" />
                </Button>
            )}

            {/* Showing list dropdown places */}
            {places.length > 0 && (
                <div className="absolute z-10 w-full bg-white border border-gray-200 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                    {places.map((place, index) => (
                        <div
                            key={index}
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
                            onClick={() => {
                                props.onChange(renderPlaceName(place), {
                                    ...place,
                                    country: getCountryFromPlace(place) || "",
                                });
                                setPlaces([]);
                            }}
                        >
                            <p className="text-md font-semibold">
                                {renderPlaceName(place)}
                                {/* {place.displayName.text} */}
                            </p>
                            <p className="text-gray-500">
                                {place.formattedAddress}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}